import { Controller } from '@hotwired/stimulus'
import { DirectUpload } from '@rails/activestorage'

export default class extends Controller {
  static targets = ['signedId']

  upload({ target: input }) {
    const [file] = input.files
    if (!file) return

    new DirectUpload(file, input.dataset.directUploadUrl, this.#progressDelegate(input)).create((error, blob) => {
      input.style.removeProperty('--upload-progress')
      if (error) return alert(error)

      this.signedIdTarget.value = blob.signed_id
      input.value = null
      this.dispatch('uploaded', { target: input })
    })
  }

  #progressDelegate(input) {
    return {
      directUploadWillStoreFileWithXHR: (request) => {
        request.upload.addEventListener('progress', ({ loaded, total }) => {
          input.style.setProperty('--upload-progress', `${loaded / total * 100}%`)
        })
      }
    }
  }
}
